import { Plugin } from "ckeditor5";
import ExpandResponseWithContextUI from "./expandResponseWithContextUI";
import ExpandResponseWithContextEditing from "./expandResponseWithContextEditing";

export default class ExpandResponseWithContext extends Plugin {
  public static get requires() {
    return [ExpandResponseWithContextEditing, ExpandResponseWithContextUI];
  }

  public static get pluginName(): string {
    return "ExpandResponseWithContext";
  }
}
